import { __assign } from "tslib";
import React from 'react';
import s from './solution-info.scss';
import { IconPreviewWrapper } from '../../preview-elements/icon-wrapper';
import { SolutionInfoDetails, dtoToDetailsProps, } from './solution-info-details';
import { SolutionInfoPreview, dtoToPreviewProps, } from './solution-info-preview';
import { getClientImageURL } from '../../../../common/getClientImageURL';
import { Avatar, Card } from 'wix-style-react';
export var dtoToInfoProps = function (solutionDto) {
    return {
        icon: solutionDto.baseInfo.icon,
        solutionDetailsProps: dtoToDetailsProps(solutionDto),
        solutionPreviewProps: dtoToPreviewProps(solutionDto),
        alt: solutionDto.baseInfo.name,
    };
};
export var SolutionInfo = function (props) {
    return (React.createElement("div", { className: s.infoLayout, "data-main-appid": props.solutionDetailsProps.id },
        React.createElement("div", { className: s.solutionDetails },
            React.createElement("div", { className: s.avatar },
                React.createElement(Card, null,
                    React.createElement(IconPreviewWrapper, { size: "62px", src: props.icon },
                        React.createElement(Avatar, { shape: "square", dataHook: "solution-icon-avatar", className: s.iconAvatar, size: "size60", imgProps: {
                                src: getClientImageURL(props.icon),
                                alt: props.alt + " logo",
                            } })))),
            React.createElement(Card, null,
                React.createElement(SolutionInfoDetails, __assign({}, props.solutionDetailsProps)))),
        React.createElement("div", { className: s.solutionGallery },
            React.createElement(SolutionInfoPreview, __assign({}, props.solutionPreviewProps)))));
};
//# sourceMappingURL=solution-info.js.map